// extracted by mini-css-extract-plugin
export default {"invalidDataError":"Season_invalidDataError__Nq3ED"};